export default (errorHolder, message, messageType) => {
    let alertComponent =  $('<div/>', {'class': 'alert alert-ajax alert-'+messageType}).html(message);
    $(errorHolder).html('');
    $(errorHolder).hide().html(alertComponent).fadeIn('fast');

    setTimeout(function() {
        $('.alert', errorHolder).fadeOut('fast');
    }, 2500);
}